export interface MyAppsHeightMeasurements {
  appsHeight: number;
  headerHeight: number;
  headerMarginBottom: number;
  paddingTop: number;
  paddingBottom: number;
  extraBottomGap: number;
}

/**
 * Calculates the height MyApps must report to the page layout.
 *
 * @param measurements - Rendered content measurements and configured spacing.
 * @returns The rounded-up widget height required to contain every app row.
 */
export const calculateMyAppsHeight = ({
  appsHeight,
  headerHeight,
  headerMarginBottom,
  paddingTop,
  paddingBottom,
  extraBottomGap,
}: MyAppsHeightMeasurements): number =>
  Math.ceil(
    appsHeight +
      headerHeight +
      headerMarginBottom +
      paddingTop +
      paddingBottom +
      extraBottomGap
  );
